/**
 * WCAG contrast ratio between two #RRGGBB colours. 4.5 is the AA floor for
 * body text; the banner configurator shows the number and warns below it.
 * Same arithmetic as the API's banner-appearance contract, so the console and
 * the server agree on the figure.
 */
export const AA_FLOOR = 4.5;

export function contrastRatio(fg: string, bg: string): number {
  const lum = (h: string): number => {
    const c = [1, 3, 5]
      .map((i) => parseInt(h.slice(i, i + 2), 16) / 255)
      .map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
    return 0.2126 * c[0]! + 0.7152 * c[1]! + 0.0722 * c[2]!;
  };
  const a = lum(fg);
  const b = lum(bg);
  const [hi, lo] = a > b ? [a, b] : [b, a];
  return Math.round(((hi + 0.05) / (lo + 0.05)) * 100) / 100;
}

export const isHex = (v: string): boolean => /^#[0-9a-fA-F]{6}$/.test(v);
